import {Locales} from '@netx/core-next/locales/utils/Locales';
import {SearchType} from './rules/constants';
import {SearchMatchCriteria} from './constants';

export const SearchTypeLabel = Locales((i18n) => ({
	[SearchType.ACTIVE_TEMPLATES]: i18n('i18n.activeTemplates'),
	[SearchType.ADVANCED_RAW]: i18n('i18n.advancedRaw'),
	[SearchType.ATTRIBUTE_HISTORY]: i18n('i18n.attributeHistory'),
	[SearchType.BRANCH_CHILDREN]: i18n('i18n.branchChildren'),
	[SearchType.CART]: i18n('i18n.cart'),
	[SearchType.CATEGORY_ID]: i18n('i18n.category'),
	[SearchType.CATEGORY_NAME]: i18n('i18n.categoryName'),
	[SearchType.CHECKOUTS]: i18n('i18n.checkouts'),
	[SearchType.CONTENTS]: i18n('i18n.contents'),
	[SearchType.CUSTOM]: i18n('i18n.custom'),
	[SearchType.DATE]: i18n('i18n.date'),
	[SearchType.EXPIRE]: i18n('i18n.expires'),
	[SearchType.FILE_ASPECT]: i18n('i18n.fileAspect'),
	[SearchType.FILE_FORMAT]: i18n('i18n.fileFormat'),
	[SearchType.FILE_FORMAT_FAMILY]: i18n('i18n.fileFormatFamily'),
	[SearchType.FILE_SIZE]: i18n('i18n.fileSize'),
	[SearchType.FILE_STATUS]: i18n('i18n.fileStatus'),
	[SearchType.KEYWORD]: i18n('i18n.keywords'),
	[SearchType.LAST_SEARCH]: i18n('i18n.lastSearch'),
	[SearchType.LOCATION]: i18n('i18n.location'),
	[SearchType.METADATA]: i18n('i18n.attributes'),
	[SearchType.METADATA_HISTORY]: i18n('i18n.metadataHistory'),
	[SearchType.PROOF]: i18n('i18n.proof'),
	[SearchType.RATING]: i18n('i18n.rating'),
	[SearchType.RELATED_ASSETS]: i18n('i18n.relatedAssets'),
	[SearchType.REVIEWS]: i18n('i18n.reviews'),
	[SearchType.SAVED_SEARCH]: i18n('i18n.savedSearch'),
	[SearchType.THESAURUS]: i18n('i18n.thesaurus'),
	[SearchType.USER]: i18n('i18n.user'),
	[SearchType.VISUAL]: i18n('i18n.visual'),
}));

export const SearchMatchCriteriaLabel = Locales((i18n) => ({
	[SearchMatchCriteria.AND]: i18n('i18n.matchAll'),
	[SearchMatchCriteria.NOT]: i18n('i18n.matchNot'),
	[SearchMatchCriteria.OR]: i18n('i18n.matchAny'),
}));

export const SearchSubTypeLabel = Locales((i18n) => ({
	MATCH_TYPE: i18n('i18n.matchType'),
}));

export const SearchRulesActionLabel = Locales((i18n) => ({
	ADD_RULE: i18n('i18n.addRule'),
	DELETE_RULE: i18n('i18n.remove'),
	RESET: i18n('i18n.reset'),
	SEARCH: i18n('i18n.search'),
}));

export const SearchRuleWarningLabel = Locales((i18n) => ({
	DATA_UNAVAILABLE: i18n('i18n.searchRuleDataUnavailable'),
}));

export const SearchRulesWarningLabel = Locales((i18n) => ({
	DATA_UNAVAILABLE: i18n('i18n.searchRulesSomeDataUnavailableWarning'),
}));
